import { useState, useCallback, useEffect } from 'react'
import { SellerServiceSessionItem, SessionHistorySummary } from '../types'
import { getSessionHistory, getSessionStatistics } from '../services'

export const useSessionHistory = (pluginspaceId: number) => {
  const [sessions, setSessions] = useState<SellerServiceSessionItem[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [summary, setSummary] = useState<SessionHistorySummary | null>(null)

  const loadHistory = useCallback(
    async (startDate?: string, endDate?: string) => {
      let loadedSessions: SellerServiceSessionItem[] = []
      try {
        setLoading(true)
        setError(null)
        
        // Se não informar datas, usar últimas 24h
        let start = startDate
        let end = endDate
        
        if (!start || !end) {
          const now = new Date()
          const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000)
          end = now.toISOString().split('T')[0]
          start = yesterday.toISOString().split('T')[0]
        }
        
        loadedSessions = await getSessionHistory(pluginspaceId, start, end)
        setSessions(loadedSessions)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erro ao carregar histórico')
        setSessions([])
      } finally {
        try {
          const stats = await getSessionStatistics(pluginspaceId)
          setSummary(stats)
        } catch (statsError) {
          // Mantem a lista de sessoes carregada, mesmo se o resumo falhar
          setSummary(null)
          if (loadedSessions.length > 0) {
            setError(null)
          }
        }
        setLoading(false)
      }
    },
    [pluginspaceId]
  )

  useEffect(() => {
    const handleSellerQueueUpdated = (event: Event) => {
      const customEvent = event as CustomEvent<{ pluginspaceId?: number }>
      const eventPluginspaceId = Number(customEvent.detail?.pluginspaceId)

      if (!pluginspaceId || eventPluginspaceId !== Number(pluginspaceId)) return

      loadHistory()
    }

    window.addEventListener('seller-queue-updated', handleSellerQueueUpdated)

    return () => {
      window.removeEventListener('seller-queue-updated', handleSellerQueueUpdated)
    }
  }, [pluginspaceId, loadHistory])

  return {
    sessions,
    loading,
    error,
    summary,
    loadHistory,
  }
}
